module.exports = __webpack_public_path__ + "static/media/ap.6d0a642c.png";